import axios from "axios";
import Config from "src/config";

const v1_actionListarFigurinhas = (querys) => {
    return axios({
        method: "get",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/chats/canais/figurinhas${querys}`,
    });
};

export default v1_actionListarFigurinhas;
